import { Component, ElementRef, HostListener, Injectable, OnInit, Inject, NgZone, Renderer2, RendererFactory2, inject } from '@angular/core';
import { NavParams } from 'src/app/components/ionic-replacements/NavParams';
import { ModalController } from 'src/app/components/ionic-replacements/ModalController';
import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { LoadingController } from 'src/app/components/ionic-replacements/LoadingController';
import { OrderDetailsProvider } from 'src/app/providers/order-details/order-details';

import { TouchcrApiShippingProvider } from 'src/app/providers/TouchcrApiShippingProvider';
import { UrlsProvider } from 'src/app/providers/urls'
import { TouchcrApiOrderformProvider } from 'src/app/providers/touchcr-api-orderform/touchcr-api-orderform';
import { GeneralProvider } from 'src/app/providers/general';
import { SpinnerProvider } from 'src/app/providers/spinner/spinner';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { TouchcrApiGeneralExtenderProvider } from 'src/app/providers/touchcr-api-general/touchcr-api-general-extender'
import { TouchcrApiOrderExtenderProvider } from 'src/app/providers/touchcr-api-order/touchcr-api-order-extender'
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from 'src/app/providers/paypal/paypal-extender'
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { CalculateProvider } from 'src/app/providers/calculate/calculate';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings'
import { ModalProvider } from 'src/app/providers/modal/modal';
import { UpsellCommon } from 'src/app/upsell/upsell-common';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { DOCUMENT } from '@angular/common';
import { PageContentBuilderService } from 'src/app/services/pageContents.service';

@Injectable({
  providedIn: 'root'
})
@HostListener('unloaded')

@Component({
  selector: 'app-us-generic',
  templateUrl: './us-generic.component.html',
  styleUrls: ['./us-generic.component.scss']
})
export class USGenericComponent extends UpsellCommon implements OnInit {
  cartQuantity: number;
  override: any;
  spinnerData: any;
  loadOnceOnly: boolean = false;
  firstName: string = '';

  public override productQuantity: number;
  public override productQuantityNextUp: number;

  public override description: string;
  public override spinButtonText: string;
  public override spinnedTitle: string;
  public override spinnedDescription: string;
  public override spinnedButtonText: string;
  public override declineButtonText: string;
  public override wheelCenterImage: string;
  public override wheelOptions: any;
  public override pointerAngle: number = 90;
  public override closeAfterSpinTime: number = 0;
  public override spinningState: string = 'not-spinning';
  public override title = 'Bio Complete 3 Title Goes Here';

  showModal: boolean = false;

  override async ngOnInit() {
    await super.ngOnInit();
  }

  openModal() {
    this.showModal = true;
    document.body.classList.add('noscroll');
    const scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    if (scrollAvoid) scrollAvoid.classList.add('avoid');
  }

  closeModal() {
    this.showModal = false;
    document.body.classList.remove('noscroll');
    const scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    if (scrollAvoid) scrollAvoid.classList.remove('avoid');
  }

  onModalCTA() {
    this.closeModal();
    // Add any CTA logic here
  }

  setModalData(modalOptionsFromService?: any) {
    // Use options passed from PageContentBuilderService if available
    let modalOptions: any = modalOptionsFromService || {};
    
    // Fallback: Try to find the upsell-modal options from the loaded pageContents (from JSON config)
    if (!modalOptionsFromService && this.pageContents && Array.isArray(this.pageContents)) {
      const modalContent = this.pageContents.find(
        c => c.componentName === 'upsell-modal' && c.options
      );
      
      if (modalContent) {
        modalOptions = modalContent.options;
      }
    }
    // Fallback to defaults if not found
    return {
      title: modalOptions.title || 'WAIT! Deeply discounted add-ons available!',
      message: modalOptions.message || 'Enjoy fantastic benefits like:<ul><li>Smoother Digestion</li><li>easier weight management</li><li>More energy</li></ul>To thank you for your business, we\'re offering you <b>DEEP DISCOUNTS</b> on formulas to help accelerate your results. You may not ever see discounts this low again — act now to secure your savings.',
      buttonText: modalOptions.buttonText || 'CLAIM YOUR DISCOUNTS',
      html: modalOptions.html || ''
    };
  }

  constructor(
    public override navCtrl: NavControllerExt,
    public override navParams: NavParams,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override loadingCtrl: LoadingController,
    public override eventStreamer: EventStreamerProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override toastCtrl: ToastController,
    public override ngZone: NgZone,

    public override shippingProvider: TouchcrApiShippingProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override stateProvider: StateProvider,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override generalProvider: GeneralProvider,
    public override spinner: SpinnerProvider,
    public modal: ModalController,
    public modalService: ModalProvider,
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    @Inject(DOCUMENT) public override document: Document,
    public override rendererFactory: RendererFactory2,
    private contentBuilder: PageContentBuilderService
  ) {
    super(
      navCtrl,
      navParams,
      tcrApi,
      tcrApiOrder,
      loadingCtrl,
      eventStreamer,
      orderDetails,
      paypalPayment,
      toastCtrl,
      ngZone,

      shippingProvider,
      tcrApiRemoteServices,
      calculateHelper,
      urlsHelper,
      stateProvider,
      tcrApiOrderform,
      funnelProvider,
      generalProvider,
      spinner,
      elementRef,
      new DynamicCurrencyPipe,
      renderer,
      document,
      rendererFactory,
    );
  }


  override setWaitData() {
    this.wait_show = true;
    this.wait_isFull = this.wait_isFull ?? false;
    this.wait_title = `${this.wait_title}`;
    this.wait_description = `${this.wait_description}`;
  }

  override setProductBoxData() {
    this.product_box_subTitle = `${this.product_box_subTitle}`
    this.product_box_show = this.product_box_show;
    this.product_box_title = `${this.product_box_title}`;
    this.product_box_showTitle = this.product_box_showTitle;
  }

  override setProductBoxFullData() {
    this.product_box_full_title = `ADD ${this.productQuantity} ${this.productUnitType} OF ${this.productBrand} ${this.productName} AND SAVE ${this.productPercent}% OFF RETAIL`;
    this.product_box_full_additionalImage = 'https://cdn.drmartypets.com/images/drmarty_arms_crossed.png';
  }

  override setGarantee01Data() {
    this.garantee_01_show = this.garantee_01_show;
    this.garantee_01_buttonYesText = `${this.garantee_01_buttonYesText}`;
    this.garantee_01_buttonNoText = `${this.garantee_01_buttonNoText}`;
    this.garantee_01_showbuttonYesText = this.garantee_01_showbuttonYesText;
    this.garantee_01_showbuttonNoText = this.garantee_01_showbuttonNoText;
    this.garantee_01_description = this.garantee_01_description;
    this.garantee_01_showDescription = this.garantee_01_showDescription;
    this.garantee_01_image = `${this.garantee_01_image}`;
    this.garantee_01_imageAlt = `${this.garantee_01_imageAlt}`;
    this.garantee_01_showImage = this.garantee_01_showImage;
  }
  
  trackByIndex(index: number, item: any): any {
    // For spinner component, use a stable identifier to prevent recreation
    if (item.componentName === 'upsell-offer-spinner') {
      return 'spinner-component';
    }
    // For other components, use index as before
    return index;
  }

  override setSection01Data() {
    this.section_01_show = true;
    // Handle both string and array formats for section01Data
    if (Array.isArray(this.section01Data)) {
      // If it's an array, use it directly
      this.section_01_content = this.section01Data;
    } else {
      // If it's a string, wrap it in the expected format
      this.section_01_content = [
        {
          id: 1,
          blocks: [`${this.section01Data}`]
        }
      ];
    }
  }
  override setSection02Data() {
    this.section_02_show = true;
    this.section_02_content = this.section02Data
  }

  override setSection03Data() {
    this.section_03_show = true;
    this.section_03_content = this.section03Data
  }



  override setStepsData() {
    this.steps_show = true;
    this.steps_items = [
      {
        id: 1,
        label: 'ORDER APPROVED',
        active: false,
        showCheck: true,
      },
      {
        id: 2,
        label: 'PRODUCT OPTIONS',
        active: true,
        showCheck: true,
      },
      {
        id: 3,
        label: 'FINAL CONFIRMATION',
        active: false,
        showCheck: false,
      },
    ];
    
    return {
      steps: this.steps_items,
      stepLabel: this.step_label,
      newStepsStyle: this.steps_newStepsStyle
    };
  }

  setProgressBarData() {
    this.progressBarTitle = `${this.progressBarTitle}`;
    this.minForFreeShipping = parseInt(`${this.minForFreeShipping}`);
    this.totalProductsSummary = parseInt(`${this.totalProductsSummary}`);
    this.progressBarLogo = `${this.progressBarLogo}`;
    this.progressBarSubTitle = `${this.progressBarSubTitle}`;
    this.progressBarCustomText = `${this.progressBarCustomText}`;
  }

  setStickyBarData() {
    return {
      summaryText: `${this.stickyBarSummaryText}`,
      addTocartText: `${this.stickyBarAddToCartText}`,
      dontAddToCartText: `${this.stickyBarDontAddToCartText}`,
    }
  }

  setStickyBarV2Data() {
    return {
      summaryText: `${this.stickyBarSummaryText}`,
      addTocartText: `${this.stickyBarAddToCartText}`,
      dontAddToCartText: `${this.stickyBarDontAddToCartText}`,
    }
  }

  setVideoPlayerData() {
    return {
      videoID: `${this.videoID}`,
      videoMessageTitle: '',
      videoMessage: '',
      videoPlayType: this.videoPlayType || 'default',
      videoClass: `${this.videoClass}`,
      videoThumbnail: `${this.videoThumbnail}`,
    }
  }

  setUpsellOfferSpinnerData() {
    this.optionsSpinner = this.optionsSpinner;
  }

  onClosed() {
  }

  setBrandReview() {
    this.reviewsTitle = `${this.reviewsTitle}`;
    
    // Use reviews from JSON file if available, otherwise use default
    // Only use JSON reviews if they exist and have content
    if (this.upsellReviews && this.upsellReviews.length > 0) {
      this.reviews = this.upsellReviews;
    } else {
      // Convert default reviews to match the expected structure
      this.reviews = this.reviews.map(review => ({
        stars: review.stars,
        headline: review.title,
        text: review.content,
        author: review.author
      }));
    }
    
    this.perReviewAddOn = this.perReviewAddOn;
    
    return {
      reviewsTitle: this.reviewsTitle,
      reviews: this.reviews,
      perReviewAddOn: this.perReviewAddOn
    };
  }
  override setFooterData() {
    // Call parent method to set default values
    super.setFooterData();
  }

  override async populatePageData(flag: any) {
    if (flag) {
      this.setHeaderData();
      this.setStepsData();
      this.setWaitData();
      this.setFooterData();
    } else {
      this.setProductData();
      await this.updateWithRoutesData();
      this.convertedPrices();
      this.setDynamicCustomerServiceInfo();
      this.setProductBoxData();
      this.setProductBoxFullData();
      this.setGarantee01Data();
      this.setUpsellOfferSpinnerData();
      this.setSection01Data();
      this.setSection02Data();
      this.setSection03Data();
      this.setFooterData();
      
      // Build page contents after all data is set
      this.pageContents = this.contentBuilder.buildPageContents(this.pageContents, this);

      // Check if upsell-modal is in pageContents and auto-open it
      const hasModal = this.pageContents.some(content => 
        content.type === 'component' && content.componentName === 'upsell-modal'
      );
      if (hasModal) {
        setTimeout(() => {
          this.openModal();
        }, 1500);
      }
    }
  }

  override async updateWithRoutesData() {
    if (!this.firstName) {
      const response = await this.stateProvider.get();
      const fullName = response?.orderDetails?.order?.customerName;
  
      if (fullName) {
        this.firstName = fullName.split(' ')[0];
        console.log('Extracted firstName:', this.firstName);
  
      } else {
        console.warn("No customerName found in orderDetails");
        this.firstName = "";
      }
  
      // Call parent method after handling firstName
      super.updateWithRoutesData();
    } else {
      super.updateWithRoutesData();
    }
  }
}
